<div class="documents-container">
  <ng-container *ngIf="!loading; else noForms">
    <!-- Registration Forms -->
    <div class="category-section">
      <h3 class="category-title">Registration Forms</h3>
      <div *ngIf="categorizedForms.registration.length === 0">
        <p>No registration forms available.</p>
      </div>
      <div class="form-grid">
        <div
          class="form-card-container"
          *ngFor="let form of categorizedForms.registration"
          (click)="navigateToForm(form)"
          [class.selected]="selectedForm === form"
        >
          <mat-card class="form-card">
            <mat-card-header>
              <mat-icon class="form-icon">
                {{ form.form_id === 'new_patient_registration' ? 'person_add' : 'assignment' }}
              </mat-icon>
              <div class="form-header-text">
                <mat-card-title>{{ form.form_title }}</mat-card-title>
              </div>
            </mat-card-header>
          </mat-card>
        </div>
      </div>
    </div>

    <!-- Consent Forms -->
    <div class="category-section">
      <h3 class="category-title">Consent Forms</h3>
      <div *ngIf="categorizedForms.consent.length === 0">
        <p>No consent forms available.</p>
      </div>
      <div class="form-grid">
        <div
          class="form-card-container"
          *ngFor="let form of categorizedForms.consent"
          (click)="navigateToForm(form)"
          [class.selected]="selectedForm === form"
        >
          <mat-card class="form-card">
            <mat-card-header>
              <mat-icon class="form-icon">
                {{ form.form_id === 'new_patient_registration' ? 'person_add' : 'assignment' }}
              </mat-icon>
              <div class="form-header-text">
                <mat-card-title>{{ form.form_title }}</mat-card-title>
              </div>
            </mat-card-header>
          </mat-card>
        </div>
      </div>
    </div>

    <!-- Other Forms -->
    <div class="category-section">
      <h3 class="category-title">Other Forms</h3>
      <div *ngIf="categorizedForms.other.length === 0">
        <p>No other forms available.</p>
      </div>
      <div class="form-grid">
        <div
          class="form-card-container"
          *ngFor="let form of categorizedForms.other"
          (click)="navigateToForm(form)"
          [class.selected]="selectedForm === form"
        >
          <mat-card class="form-card">
            <mat-card-header>
              <mat-icon class="form-icon">
                {{ form.form_id === 'new_patient_registration' ? 'person_add' : 'assignment' }}
              </mat-icon>
              <div class="form-header-text">
                <mat-card-title>{{ form.form_title }}</mat-card-title>
              </div>
            </mat-card-header>
          </mat-card>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-template #noForms>
    <div class="no-forms-message">
      <mat-progress-spinner [diameter]="50" color="primary"></mat-progress-spinner>
      <p>Loading forms...</p>
    </div>
  </ng-template>
</div>
